import CaptchaErrorAlert from './CaptchaErrorAlert';

export default CaptchaErrorAlert;
